import BackgroundComponent from "../../components/background";

export default function ErrorScreen() {
  return (
    <div>
      <BackgroundComponent />
      <div className="account-pages py-auto position-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-xxl-4 col-lg-5"
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="card">
                {/* Logo */}
                <div className="card-header py-4 text-center border-bottom">
                  <a href="index.html">
                    <span>
                      <img
                        src="assets/images/logo.png"
                        alt="logo"
                        height={66}
                      />
                    </span>
                  </a>
                </div>
                <div className="card-body p-4">
                  <div className="text-center">
                    <h1 className="text-error">
                      4<i className="mdi mdi-emoticon-sad" />4
                    </h1>
                    <h4 className="text-uppercase text-danger mt-3">
                      Хуудас олдсонгүй
                    </h4>
                    <a className="btn btn-primary mt-3" href="/">
                      <i className="mdi mdi-reply" /> Буцах
                    </a>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
